export enum INavPaths {
  CORE_DOCUMENTS = '/core-documents',
  INQUIRY_DOCUMENTS = '/call-in-documents',
}

export enum IRoutesItems {
  CATEGORY = 'catId',
  SUBCATEGORYID = 'subCatId',
  '*' = '*',
}

const NavItems = [
  {
    path: '/',
    name: 'Home',
  },
  {
    path: INavPaths.CORE_DOCUMENTS,
    name: 'Core Documents',
  },
  // {
  //   path: INavPaths.INQUIRY_DOCUMENTS,
  //   name: 'Call-In Documents',
  // },
];

export default NavItems;
